namespace Matrix.Visualizer {
    export interface GraphEdgeRow {
        EdgeId?: number;
        ParentNodeId?: number;
        ChildNodeId?: number;
        Caption?: string;
        Tooltip?: string;
        Thickness?: number;
        Colour?: string;
        FromArrow?: string;
        ToArrow?: string;
        FromArrowColour?: string;
        ToArrowColour?: string;
        ContextMenuTemplate?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ParentNodeGraphInstanceId?: number;
        ParentNodeKey?: string;
        ParentNodeCaption?: string;
        ParentNodeTooltip?: string;
        ParentNodeShapeName?: string;
        ParentNodeBorderColour?: string;
        ParentNodeBackgroundColour?: string;
        ParentNodeTextColour?: string;
        ParentNodeTextFont?: string;
        ParentNodeTextAlign?: string;
        ParentNodeTextUnderline?: boolean;
        ParentNodeContextMenuTemplate?: string;
        ParentNodeRowId?: number;
        ChildNodeGraphInstanceId?: number;
        ChildNodeKey?: string;
        ChildNodeCaption?: string;
        ChildNodeTooltip?: string;
        ChildNodeShapeName?: string;
        ChildNodeBorderColour?: string;
        ChildNodeBackgroundColour?: string;
        ChildNodeTextColour?: string;
        ChildNodeTextFont?: string;
        ChildNodeTextAlign?: string;
        ChildNodeTextUnderline?: boolean;
        ChildNodeContextMenuTemplate?: string;
        ChildNodeRowId?: number;
    }

    export namespace GraphEdgeRow {
        export const idProperty = 'EdgeId';
        export const nameProperty = 'Caption';
        export const localTextPrefix = 'Visualizer.GraphEdge';
        export const lookupKey = 'Visualizer.GraphEdge';

        export function getLookup(): Q.Lookup<GraphEdgeRow> {
            return Q.getLookup<GraphEdgeRow>('Visualizer.GraphEdge');
        }
        export const deletePermission = 'DataAdmin:Visualizer';
        export const insertPermission = 'DataAdmin:Visualizer';
        export const readPermission = 'Read:Visualizer';
        export const updatePermission = 'DataAdmin:Visualizer';

        export declare const enum Fields {
            EdgeId = "EdgeId",
            ParentNodeId = "ParentNodeId",
            ChildNodeId = "ChildNodeId",
            Caption = "Caption",
            Tooltip = "Tooltip",
            Thickness = "Thickness",
            Colour = "Colour",
            FromArrow = "FromArrow",
            ToArrow = "ToArrow",
            FromArrowColour = "FromArrowColour",
            ToArrowColour = "ToArrowColour",
            ContextMenuTemplate = "ContextMenuTemplate",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ParentNodeGraphInstanceId = "ParentNodeGraphInstanceId",
            ParentNodeKey = "ParentNodeKey",
            ParentNodeCaption = "ParentNodeCaption",
            ParentNodeTooltip = "ParentNodeTooltip",
            ParentNodeShapeName = "ParentNodeShapeName",
            ParentNodeBorderColour = "ParentNodeBorderColour",
            ParentNodeBackgroundColour = "ParentNodeBackgroundColour",
            ParentNodeTextColour = "ParentNodeTextColour",
            ParentNodeTextFont = "ParentNodeTextFont",
            ParentNodeTextAlign = "ParentNodeTextAlign",
            ParentNodeTextUnderline = "ParentNodeTextUnderline",
            ParentNodeContextMenuTemplate = "ParentNodeContextMenuTemplate",
            ParentNodeRowId = "ParentNodeRowId",
            ChildNodeGraphInstanceId = "ChildNodeGraphInstanceId",
            ChildNodeKey = "ChildNodeKey",
            ChildNodeCaption = "ChildNodeCaption",
            ChildNodeTooltip = "ChildNodeTooltip",
            ChildNodeShapeName = "ChildNodeShapeName",
            ChildNodeBorderColour = "ChildNodeBorderColour",
            ChildNodeBackgroundColour = "ChildNodeBackgroundColour",
            ChildNodeTextColour = "ChildNodeTextColour",
            ChildNodeTextFont = "ChildNodeTextFont",
            ChildNodeTextAlign = "ChildNodeTextAlign",
            ChildNodeTextUnderline = "ChildNodeTextUnderline",
            ChildNodeContextMenuTemplate = "ChildNodeContextMenuTemplate",
            ChildNodeRowId = "ChildNodeRowId"
        }
    }
}
